import type { ServiceRequestData, SmsOptInData } from './validation';

interface ApiResponse {
  success: boolean;
  message: string;
}

async function post<T>(url: string, data: T): Promise<ApiResponse> {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message: result.message || 'An error occurred. Please try again.',
      };
    }

    return {
      success: true,
      message: result.message || 'Success',
    };
  } catch {
    return {
      success: false,
      message: 'Unable to connect to the server. Please check your internet connection and try again.',
    };
  }
}

export async function submitServiceRequest(data: ServiceRequestData): Promise<ApiResponse> {
  return post('/api/service-requests', data);
}

export async function submitSmsOptIn(data: SmsOptInData): Promise<ApiResponse> {
  return post('/api/sms-opt-ins', data);
}
